module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-qy-light.c88da160.png";